import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { OrderResult } from '../../../../core/services/orders/order.models';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { TransactionsService } from '../../../../core/services/transactions/transactions.service';
import { Transaction } from '../../../../core/services/transactions/transactions.model';

@Injectable()
export class InvoicepageService implements Resolve<any> {

    routeParams: any;
    order: OrderResult;
    transactions: Transaction[];
    dueAmount: number;
    onOrderChanged: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        private orderService: OrdersService,
        private readonly transactionService: TransactionsService,
    ) {}

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {

        this.routeParams = route.params;

        return new Promise((resolve, reject) => {

            Promise.all([
                this.getOrder()
            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getOrder(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            Observable.zip(
                this.orderService.get(this.routeParams.id),
                this.transactionService.listOrder(this.routeParams.id),
                this.transactionService.dueAmount(this.routeParams.id),
                (order: OrderResult, transactions: Transaction[], dueAmount: number) => ({order, transactions, dueAmount})
            )
            .subscribe((pair) => {
                this.order = pair.order;
                this.transactions = pair.transactions;
                this.dueAmount = pair.dueAmount;
                this.onOrderChanged.next([this.order, this.transactions, this.dueAmount]);
                resolve(true);
            }, reject);
        });
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/invoicepage/invoicepage.service.ts